import CryptoJS from 'crypto-js'

import api from '@/api'
import { KEY_COMPANY_ID } from '@/fixtures/Constants'
import { CRYPTO_KEY } from '@/fixtures/Hash'

const encCompanyId = btoa(KEY_COMPANY_ID)
const namespaced = true

const state = {
  companyId: localStorage.getItem(encCompanyId) || null,
  bargePerformances: [],
  bargePerformanceDetail: null,
  tugOwners: []
}

const getters = {
  companyId: state => state.companyId
    ? Number(CryptoJS.AES.decrypt(state.companyId, CRYPTO_KEY).toString(CryptoJS.enc.Utf8))
    : null,
  bargePerformances: state => state.bargePerformances,
  bargePerformanceDetail: state => state.bargePerformanceDetail,
  tugOwners: state => state.tugOwners
}

const mutations = {
  SET_COMPANY_ID: (state, payload) => {
    state.companyId = payload
    localStorage.setItem(encCompanyId, payload)
  },
  SET_BARGE_PERFORMANCES: (state, payload) => {
    state.bargePerformances = payload
  },
  SET_BARGE_PERFORMANCE_DETAIL: (state, payload) => {
    state.bargePerformanceDetail = payload
  },
  SET_TUG_OWNERS: (state, payload) => {
    state.tugOwners = payload
  }
}

const actions = {
  async fetchBargePerformances({ commit }, payload) {
    try {
      const { data } = await api.getBargePerformances(payload)

      if (data.error) {
        commit('SET_BARGE_PERFORMANCES', [])
        return
      }

      commit('SET_BARGE_PERFORMANCES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchBargePerformanceDetail({ commit }, payload) {
    try {
      commit('SET_COMPANY_ID', CryptoJS.AES.encrypt(payload.id.toString(), CRYPTO_KEY).toString())
      const { data } = await api.getBargePerformance(payload.id, payload.filter)
      if (data.error) {
        commit('SET_BARGE_PERFORMANCE_DETAIL', null)
        return
      }
      commit('SET_BARGE_PERFORMANCE_DETAIL', data)
    } catch (err) {
      throw err
    }
  },
  async fetchTugOwners({ commit }) {
    try {
      const { data } = await api.getTugOwners()

      if (data.error) {
        commit('SET_TUG_OWNERS', [])
        return
      }
      commit('SET_TUG_OWNERS', data)
    } catch (err) {
      throw err
    }
  },
  async postCompanyPerformance({}, payload) {
    try {
      await api.postCompanyPerformance(payload)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
